module.exports = __webpack_public_path__ + "img/gi.e689529.png";